var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.95 3.05a7 7 0 10-9.9 9.9 6.999 6.999 0 109.9-9.9zM13.5 8a5.472 5.472 0 01-1.119 3.32L4.68 3.62A5.472 5.472 0 018 2.5c3.033 0 5.5 2.469 5.5 5.5zm-11 0a5.472 5.472 0 011.119-3.32l7.702 7.701A5.472 5.472 0 018 13.5 5.507 5.507 0 012.5 8z"
  })));
}
export default SvgBannedIcon;